// src/components/ConsentBanner.jsx
// Asks once whether anonymous usage statistics may be collected. Nothing is collected before the answer, and the
// app works the same with either. The footer's "Privacy settings" asks again.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { consentChoice, setConsent, subscribeToConsent, subscribeToConsentReview } from '../analytics';
import { CheckIcon } from './icons';

function ConsentBanner() {
    const [choice, setChoice] = useState(consentChoice());
    const [reviewing, setReviewing] = useState(false);

    useEffect(() => subscribeToConsent(setChoice), []);
    useEffect(() => subscribeToConsentReview(() => setReviewing(true)), []);

    const decided = choice !== null;
    if (decided && !reviewing) return null; // already answered, and nobody asked to see it again

    const decide = (value) => {
        setConsent(value);
        setReviewing(false);
    };

    return (
        <div className="consent-banner" role="dialog" aria-label="Usage statistics">
            <p>
                {decided
                    ? `Usage statistics (Google Analytics) are currently ${choice === 'granted' ? 'on' : 'off'}. Change your answer, or close this to keep it.`
                    : 'May we collect anonymous usage statistics (Google Analytics) to improve the app? The app works the same either way.'}{' '}
                <Link to="/privacy">Privacy policy</Link>
            </p>
            <div className="consent-actions">
                <button className="btn btn-sm" aria-pressed={choice === 'denied'} onClick={() => decide('denied')}>
                    {choice === 'denied' && <CheckIcon size={14} />} No, thanks
                </button>
                <button className="btn btn-sm btn-primary" aria-pressed={choice === 'granted'} onClick={() => decide('granted')}>
                    {choice === 'granted' && <CheckIcon size={14} />} Yes, that is fine
                </button>
                {decided && (
                    <button className="btn btn-sm btn-ghost" onClick={() => setReviewing(false)}>
                        Close
                    </button>
                )}
            </div>
        </div>
    );
}

export default ConsentBanner;
